package com.karyadina.freesource.di

import com.karyadina.freesource.repository.FreeSourceRepository
import com.karyadina.freesource.viewmodel.FreeSourceViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val freeSourceModule = module {
    single { FreeSourceRepository() }
    viewModelOf(::FreeSourceViewModel)
}
